import { createDateFormat, generateApiUrl, generateLang } from "@/shared/utils";

/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";

export const getTerm = async (code) => {
  try {
    const url = generateApiUrl(["profile", "term_id"], [code]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const permissions = pathOr([], ['data', 'permissions'], response);
    return { ...data, permissions };
  } catch (error) {
    throw error;
  }
};
export const getTermV2 = async (code) => {
  try {
    const url = generateApiUrl(["profile", "v2", "term"], [code]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const linkShow = pathOr(false, ["link_show"], data);

    return {
      startDate: createDateFormat(pathOr("", ["start_date", "jalali"], data)),
      endDate: createDateFormat(pathOr("", ["end_date", "jalali"], data)),
      license: pathOr("", ["license", "caption"], data),
      cooperation: pathOr("", ["cooperation", "caption"], data),
      linkShow: linkShow ? generateLang(["yes"]) : generateLang(["no"]),
      preRegisterCode: pathOr(null, ["pre_register_code"], data),
      levelsCount: pathOr("", ["levels_count"], data),
      createdBy: pathOr(null, ["created_by", "name"], data),
      createdAt: createDateFormat(pathOr(null, ["created_at", "jalali"], data)),
    };
  } catch (error) {
    throw error;
  }
};
export const removeTerm = async (code) => {
  try {
    const url = generateApiUrl(["profile", "term_id"], [code]);
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const addTerm = async (
  companyCode,
  caption,
  startDate,
  endDate,
  linkCaption
) => {
  try {
    const url = generateApiUrl(["profile", "term"]);
    const payload = {
      company_code: companyCode,
      caption,
      start_date: startDate,
      end_date: endDate,
      link_caption: linkCaption,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const editGeneralInformationTerm = async ({
  termCode,
  status,
  termTitle,
  startDate,
  endDate,
  checkTwoStepVerification,
  directLogin,
  licenseType,
  cooperationType,
  limitRegistration,
  defaultRole,
  azmoon,
  preRegisterKindSelectAzmoonId,
  description,
}) => {
  try {
    const url = generateApiUrl(["profile", "v2", "term"], [termCode]);
    const payload = {
      status,
      caption: termTitle,
      start_date: startDate,
      end_date: endDate,
      two_step_verification: checkTwoStepVerification,
      direct_login: directLogin,
      license_id: licenseType,
      cooperation_id: cooperationType,
      limit_registration: limitRegistration,
      role_code: defaultRole,
      azmoon_id: azmoon,
      pre_register_kind_select_azmoon_id: preRegisterKindSelectAzmoonId,
      description,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const editRegisterTypeTerm = async ({
  termCode,
  registerLinkCaption,
  showRegisterLink,
  registerCondition,
  registerType,
  linkRegisterCodeCaption,
  linkCheckNationalCode,
}) => {
  try {
    const url = generateApiUrl(
      ["profile", "v2", "term_id_register"],
      [termCode]
    );
    const payload = {
      link_caption: registerLinkCaption,
      link_show: showRegisterLink,
      register_condition: registerCondition,
      link_register_by_code: registerType,
      link_register_code_caption: linkRegisterCodeCaption,
      link_check_national_code: linkCheckNationalCode,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const getAllTermRegisterCode = async (
  termCode,
  page = 1,
  getPerPage = 10
) => {
  try {
    const queryString = { page, per_page: getPerPage };
    const url = generateApiUrl(
      ["profile", "term_register_code"],
      [termCode],
      queryString
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const total = pathOr(0, ["total"], data);
    const count = pathOr(0, ["count"], data);
    const totalPages = pathOr(0, ["total_pages"], data);
    const currentPage = pathOr(1, ["current_page"], data);
    const perPage = pathOr(10, ["per_page"], data);
    const items = pathOr([], ["result"], data);

    return { total, count, totalPages, currentPage, perPage, items };
  } catch (error) {
    throw error;
  }
};
export const addTermRegisterCode = async (
  termCode,
  registerCode,
  nationalCode
) => {
  try {
    const url = generateApiUrl(["profile", "term_register_code"], [termCode]);
    const payload = { code: registerCode, national_code: nationalCode };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const removeRegisterCode = async (termCode, id) => {
  try {
    const url = generateApiUrl(
      ["profile", "term_register_code_id"],
      [termCode, id]
    );
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const getAllTermState = async (termCode, page = 1, getPerPage = 10) => {
  try {
    const queryString = { page, per_page: getPerPage };
    const url = generateApiUrl(
      ["profile", "term_state"],
      [termCode],
      queryString
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const total = pathOr(0, ["total"], data);
    const count = pathOr(0, ["count"], data);
    const totalPages = pathOr(0, ["total_pages"], data);
    const currentPage = pathOr(1, ["current_page"], data);
    const perPage = pathOr(10, ["per_page"], data);
    const items = pathOr([], ["result"], data);

    return { total, count, totalPages, currentPage, perPage, items };
  } catch (error) {
    throw error;
  }
};
export const getOneTermState = async (termCode, termStateCode) => {
  try {
    const url = generateApiUrl(
      ["profile", "term_state_id"],
      [termCode, termStateCode]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    return data;
  } catch (error) {
    throw error;
  }
};
export const addTermState = async ({
  termCode,
  isEnable,
  stateName,
  statePrerequisiteName,
  maxDayStatusCompleted,
  cost,
  gate,
  startDate,
  endDate,
}) => {
  try {
    const url = generateApiUrl(["profile", "term_state"], [termCode]);
    const payload = {
      is_enable: isEnable,
      state_name: stateName,
      state_prerequisite_name: statePrerequisiteName,
      max_day_status_completed: maxDayStatusCompleted,
      cost,
      gate_code: gate,
      start_date: startDate,
      end_date: endDate,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const editTermState = async ({
  termCode,
  termStateCode,
  isEnable,
  stateName,
  statePrerequisiteName,
  maxDayStatusCompleted,
  cost,
  gate,
  startDate,
  endDate,
}) => {
  try {
    const url = generateApiUrl(
      ["profile", "term_state_id"],
      [termCode, termStateCode]
    );
    const payload = {
      is_enable: isEnable,
      state_name: stateName,
      state_prerequisite_name: statePrerequisiteName,
      max_day_status_completed: maxDayStatusCompleted,
      cost,
      gate_code: gate,
      start_date: startDate,
      end_date: endDate,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const removeTermState = async (termCode, id) => {
  try {
    const url = generateApiUrl(["profile", "term_state_id"], [termCode, id]);
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const editTermExtraProfile = async ({
  termCode,
  profileImage,
  birthDate,
  educationGrade,
  sokonatCity,
  jobInfo,
}) => {
  try {
    const url = generateApiUrl(["profile", "term_extra_profile"], [termCode]);
    const payload = {
      profile_image: profileImage,
      birth_date: birthDate,
      education_grade: educationGrade,
      sokonat_city: sokonatCity,
      job_info: jobInfo,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const editTermExtraAttachment = async (termCode, attachment) => {
  try {
    const url = generateApiUrl(
      ["profile", "term_extra_attachment"],
      [termCode]
    );
    const payload = { attachment };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
